export default __webpack_public_path__ + "static/media/customer-review.0a530c93.png";